<template>
  <app-layout>
    <v-card class="ma-3 pa-3">
      <!-- Resume -->
      <v-card-title class="pt-0">
        <v-layout row wrap>
          <v-flex xs12 md4>
            <v-layout align-center justify-start row fill-height>
              <div>
                <h2>Ventas</h2>
              </div>
              <div class="ml-3">
                <v-select
                  class="fit"
                  color="primary"
                  v-model="selectedYear"
                  item-text="text"
                  item-value="value"
                  :items="years"
                ></v-select>
              </div>
              <div class="ml-3">
                <v-select
                  class=""
                  color="primary"
                  v-model="selectedQuarter"
                  item-text="text"
                  item-value="value"
                  :items="quarters"
                ></v-select>
              </div>
            </v-layout>
          </v-flex>
          <v-flex xs12 md8>
            <!-- Action buttons -->
            <v-layout align-center justify-end row fill-height>
              <div v-if="selectedTableItems.length >= 1">
                <v-btn color="green" @click="onUnblockInvoices()">
                  <v-icon left>mdi-alert-octagon</v-icon>
                  {{ $t('DESCONTABILIZAR FACTURAS') }}
                  <v-progress-circular
                    v-if="unblockingInvoices"
                    class="ml-2"
                    :size="20"
                    indeterminate
                    color="black"
                  ></v-progress-circular>
                </v-btn>
                <v-btn color="red" @click="onBlockInvoices()">
                  <v-icon left>mdi-alert-octagon</v-icon>
                  {{ $t('CONTABILIZAR FACTURAS') }}
                  <v-progress-circular
                    v-if="blockingInvoices"
                    class="ml-2"
                    :size="20"
                    indeterminate
                    color="black"
                  ></v-progress-circular>
                </v-btn>
                <v-btn color="info" @click="onBulkDownloadPdf()">
                  <v-icon left>mdi-download</v-icon>
                  {{ $t('DESCARGAR PDF') }}
                  <v-progress-circular
                    v-if="downloadingPDF"
                    class="ml-2"
                    :size="20"
                    indeterminate
                    color="black"
                  ></v-progress-circular>
                </v-btn>
                <v-btn color="light" @click="exportToExcel()" :disabled="exportingExcel">
                  <v-icon left>mdi-file-excel-outline</v-icon>
                  {{ $t('Exportar a excel') }}
                  <v-progress-circular
                    v-if="exportingExcel"
                    class="ml-2"
                    :size="20"
                    indeterminate
                    color="black"
                  ></v-progress-circular>
                </v-btn>
              </div>
            </v-layout>
            <!-- End action buttons -->
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <open-billing-invoice-table
          ref="openbillingInvoiceTable"
          :year="selectedYear"
          :quarter="selectedQuarter"
          invoice-type="factura"
          @on-selected-items="onSelectedItems($event)"
          @on-show-invoice="onShowInvoice($event)"
          @on-download-pdf="onDownloadPdf($event)"
        ></open-billing-invoice-table>
      </v-card-text>
    </v-card>
    <open-billing-invoice-form
      v-if="showInvoiceModalForm"
      :show-modal="showInvoiceModalForm"
      :key="invoiceFormKey"
      :invoice-id="selectedInvoiceId"
      invoice-type="factura"
      @click-on-close="closeInvoiceModalForm()"
    ></open-billing-invoice-form>
    <!-- Generate pdf for selected invoices -->
    <v-layout row wrap v-if="downloadingPDF">
      <v-flex xs12 class="ma-3">
        <v-expansion-panel>
          <v-expansion-panel-content>
            <template v-slot:header>
              <div>Descargando PDF</div>
              <v-progress-linear :indeterminate="true" style="width: 85%"></v-progress-linear>
            </template>
            <open-billing-generate-invoice-pdf
              id="element-to-print"
              :invoices="selectedInvoicesToGeneratePDF"
              invoice-type="factura"
              :key="resetGeneratePdfKey"
            ></open-billing-generate-invoice-pdf>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </v-layout>
    <!-- Modal to block bulk invoices -->
    <v-layout row justify-center>
      <v-dialog v-model="showBulkBlockInvoiceModal" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Contabilizar facturas') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                  <h2>
                    ¿Estás seguro de contabilizar las facturas seleccionadas?
                  </h2>
                  <small>Esta acción no permitirá al cliente editar las facturas</small>
                </v-flex>
                <v-flex xs12 class="text-xs-center">
                  <v-checkbox
                    v-model="sendConversationWhenBlockInvoices"
                    label="Enviar mensaje a los usuarios notificando que las facturas han sido contabilizadas y no se permite su edición"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="showBulkBlockInvoiceModal = false">
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn color="error" @click="confirmBlockBulkInvoices()">
              {{ $t('Contabilizar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->
    <!-- Modal to unblock bulk invoices -->
    <v-layout row justify-center>
      <v-dialog v-model="showBulkUnblockInvoiceModal" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Descontabilizar facturas') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                  <h2>
                    ¿Estás seguro de descontabilizar las facturas seleccionadas?
                  </h2>
                  <small>Esta acción permitirá al cliente editar las facturas</small>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="showBulkUnblockInvoiceModal = false">
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn color="error" @click="confirmUnblockBulkInvoices()">
              {{ $t('Descontabilizar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->
    <v-snackbar v-model="snack" bottom right :timeout="3000" :color="snackColor">
      {{ snackText }}
    </v-snackbar>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout';
import OpenBillingInvoiceTable from '@/modules/admin/billing/components/BillingAdminInvoiceTable';
import OpenBillingInvoiceForm from '@/modules/admin/billing/components/BillingAdminInvoiceForm';
import apiCtrl from '@/services/api/abstract/abstract-api';
import html2pdf from 'html2pdf.js';
import OpenBillingGenerateInvoicePdf from '../../../openbilling/components/OpenBillingGenerateInvoicePDF';
import { generateCalculatedTotalSelectedInvoice } from '@/modules/openbilling/helpers/invoiceHelper';

export default {
  name: 'BillingAdminInvoiceSales',
  components: {
    AppLayout,
    OpenBillingGenerateInvoicePdf,
    'open-billing-invoice-table': OpenBillingInvoiceTable,
    'open-billing-invoice-form': OpenBillingInvoiceForm,
  },
  props: [],
  data() {
    return {
      selectedYear: new Date().getFullYear(),
      years: [],
      quarters: [
        {
          text: 'Año completo',
          value: null,
        },
        {
          text: '1er Trimestre',
          value: 1,
        },
        {
          text: '2o Trimestre',
          value: 2,
        },
        {
          text: '3er Trimestre',
          value: 3,
        },
        {
          text: '4o Trimestre',
          value: 4,
        },
      ],
      selectedQuarter: null,
      totalAmountInvoiced: 0,
      totalAmountWithoutPay: 0,
      showInvoiceModalForm: false,
      showBulkBlockInvoiceModal: false,
      showBulkUnblockInvoiceModal: false,
      sendConversationWhenBlockInvoices: false,
      invoiceFormKey: 0,
      selectedInvoiceId: null,
      selectedTableItems: [],
      resetGeneratePdfKey: 0,
      selectedInvoicesToGeneratePDF: [],
      downloadingPDF: false,
      exportingExcel: false,
      blockingInvoices: false,
      unblockingInvoices: false,
      invoiceType: 'factura',
      invoiceLogo: null,
      snack: false,
      snackText: '',
      snackColor: 'info',
    };
  },
  mounted() {
    this.getYears();
  },
  computed: {},
  methods: {
    showSnackMessage(action, message) {
      this.snackColor = action;
      this.snackText = message;
      this.snack = true;
    },
    getBillingInvoices() {
      this.$refs['openbillingInvoiceTable'].getBillingInvoices();
    },
    getYears() {
      const currentDate = new Date();
      let startYear = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1;

      // If it is november or december we add the next year in the range
      if (month >= 11) {
        startYear = startYear + 1;
      }
      let years = [];
      for (let i = 10; i >= 0; i--) {
        years.push({ text: startYear - i, value: startYear - i });
      }
      this.years = years.sort((a, b) => b.value - a.value);
    },
    onSelectedItems(selectedItems) {
      this.selectedTableItems = selectedItems;
    },
    onShowInvoice(invoice) {
      this.selectedInvoiceId = invoice.id;
      this.showInvoiceModalForm = true;
    },
    closeInvoiceModalForm() {
      this.showInvoiceModalForm = false;
      this.selectedInvoiceId = null;
      this.invoiceFormKey++;
    },
    onBulkDownloadPdf() {
      this.downloadingPDF = true;
      this.selectedInvoicesToGeneratePDF = [];
      this.selectedTableItems.forEach(item => {
        let processedInvoice = this.generateCalculatedTotalSelectedInvoice(item);
        this.selectedInvoicesToGeneratePDF.push(processedInvoice);
      });

      this.resetGeneratePdfKey = this.resetGeneratePdfKey + 1;
      setTimeout(() => {
        const fileName = `Facturas_seleccionadas_${this.resetGeneratePdfKey}`;
        this.generatePDF(fileName);
      }, 2000);
    },
    onDownloadPdf(invoice) {
      this.downloadingPDF = true;
      this.selectedInvoicesToGeneratePDF = [];
      let processedInvoice = this.generateCalculatedTotalSelectedInvoice(invoice);
      this.selectedInvoicesToGeneratePDF.push(processedInvoice);
      this.resetGeneratePdfKey = this.resetGeneratePdfKey + 1;
      setTimeout(() => {
        const fileName = `Factura_${invoice.code}`;
        this.generatePDF(fileName);
      }, 1000);
    },
    generateCalculatedTotalSelectedInvoice(invoice) {
      return generateCalculatedTotalSelectedInvoice(invoice);
    },
    createEmptyTotalSelectedInvoiceData() {
      return {
        totalTaxBase: 0,
        totalDiscount: 0,
        totalAmount: 0,
        totalTaxes: 0,
        totalIrpf: 0,
        totalTax21: 0,
        totalTax10: 0,
        totalTax4: 0,
        totalIrpf19: 0,
        totalIrpf15: 0,
        totalIrpf7: 0,
        totalIrpf2: 0,
        totalIrpf1: 0,
      };
    },
    generatePDF(fileName) {
      let element = document.getElementById('element-to-print');
      let opt = {
        margin: 1,
        filename: `${fileName}.pdf`,
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 2, backgroundColor: '#ffffff' },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
      };
      html2pdf()
        .set(opt)
        .from(element)
        .save();

      this.downloadingPDF = false;
    },
    async exportToExcel() {
      this.exportingExcel = true;
      import('../../../../plugins/Export2Excel.js').then(async excel => {
        const pagination = this.$refs['openbillingInvoiceTable'].invoicesPagination;
        const filters = this.$refs['openbillingInvoiceTable'].filters;
        let selectedIds = [];
        if (!this.$refs['openbillingInvoiceTable'].selectAllRows) {
          this.selectedTableItems.forEach(item => {
            selectedIds = selectedIds.concat(item['id']);
          });
        }
        const config = {
          params: {
            page: 1,
            per_page: -1,
            sort_by: pagination.sortBy,
            descending: pagination.descending,
            search: filters.search,
            status: filters.status,
            contact_id: filters.contact_id,
            month: filters.month,
            year: filters.year,
            clavedat: filters.clavedat,
            quarter: filters.quarter,
            payment_method: filters.payment_method,
            doc_type: this.invoiceType,
            selected_ids: selectedIds,
            blocked: filters.blocked,
          },
        };

        let headers = [];
        let dataToExport = [];
        await apiCtrl
          .get(`/adminbilling/invoices/list/export-excel`, config)
          .then(res => {
            console.log(res.data);
            headers = res.data.headers;
            dataToExport = res.data.data;
          })
          .catch(() => {
            this.showSnackMessage('error', 'Se ha producido un error al exportar los datos');
            this.exportingExcel = false;
          });
        let exportHeaders = headers.map(header => header.text);
        const exportColumns = headers.map(header => header.value);
        const exportList = this.formatJson(exportColumns, dataToExport);
        const quarterFileName = filters.quarter ? `Q${filters.quarter}` : 'año completo';
        excel.export_json_to_excel({
          header: exportHeaders,
          data: exportList,
          filename: `Reporte Facturas`,
          autoWidth: true,
          bookType: 'xlsx',
        });
        this.exportingExcel = false;
      });
    },
    onBlockInvoices() {
      const filters = this.$refs['openbillingInvoiceTable'].filters;
      if (filters.clavedat) {
        this.sendConversationWhenBlockInvoices = false;
        this.showBulkBlockInvoiceModal = true;
      } else {
        this.showSnackMessage('error', 'Es necesario seleccionar una empresa');
      }
    },
    onUnblockInvoices() {
      const filters = this.$refs['openbillingInvoiceTable'].filters;
      if (filters.clavedat) {
        this.showBulkUnblockInvoiceModal = true;
      } else {
        this.showSnackMessage('error', 'Es necesario seleccionar una empresa');
      }
    },
    async confirmBlockBulkInvoices() {
      this.showBulkBlockInvoiceModal = false;
      this.blockingInvoices = true;
      const pagination = this.$refs['openbillingInvoiceTable'].invoicesPagination;
      const filters = this.$refs['openbillingInvoiceTable'].filters;

      let selectedIds = [];
      if (!this.$refs['openbillingInvoiceTable'].selectAllRows) {
        this.selectedTableItems.forEach(item => {
          selectedIds = selectedIds.concat(item['id']);
        });
      }
      const config = {
        page: 1,
        per_page: -1,
        sort_by: pagination.sortBy,
        descending: pagination.descending,
        search: filters.search,
        status: filters.status,
        contact_id: filters.contact_id,
        month: filters.month,
        year: filters.year,
        clavedat: filters.clavedat,
        quarter: filters.quarter,
        payment_method: filters.payment_method,
        doc_type: this.invoiceType,
        selected_ids: selectedIds,
        send_message_after_block: this.sendConversationWhenBlockInvoices,
        blocked: filters.blocked,
      };

      await apiCtrl
        .post(`/adminbilling/invoices/block`, config)
        .then(res => {
          console.log(res.data);
          this.blockingInvoices = false;
          this.getBillingInvoices();
        })
        .catch(() => {
          this.showSnackMessage('error', 'Se ha producido un error al contabilizar las facturas');
          this.blockingInvoices = false;
        });
    },
    async confirmUnblockBulkInvoices() {
      this.showBulkUnblockInvoiceModal = false;
      this.unblockingInvoices = true;
      const pagination = this.$refs['openbillingInvoiceTable'].invoicesPagination;
      const filters = this.$refs['openbillingInvoiceTable'].filters;

      let selectedIds = [];
      if (!this.$refs['openbillingInvoiceTable'].selectAllRows) {
        this.selectedTableItems.forEach(item => {
          selectedIds = selectedIds.concat(item['id']);
        });
      }
      const config = {
        page: 1,
        per_page: -1,
        sort_by: pagination.sortBy,
        descending: pagination.descending,
        search: filters.search,
        status: filters.status,
        contact_id: filters.contact_id,
        month: filters.month,
        year: filters.year,
        clavedat: filters.clavedat,
        quarter: filters.quarter,
        payment_method: filters.payment_method,
        doc_type: this.invoiceType,
        selected_ids: selectedIds,
        send_message_after_block: this.sendConversationWhenBlockInvoices,
        blocked: filters.blocked,
      };

      await apiCtrl
        .post(`/adminbilling/invoices/unblock`, config)
        .then(res => {
          console.log(res.data);
          this.unblockingInvoices = false;
          this.getBillingInvoices();
        })
        .catch(() => {
          this.showSnackMessage(
            'error',
            'Se ha producido un error al descontabilizar las facturas',
          );
          this.unblockingInvoices = false;
        });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        }),
      );
    },
  },
  watch: {},
};
</script>

<style scoped>
.v-select.fit {
  width: min-content !important;
}
</style>
